import React from 'react';
import { useTranslation } from 'react-i18next';

import Container from 'components/Container';

import { Section, Content, Item } from './WhoAreWe.styles';

const WhoAreWe = () => {
  const [t] = useTranslation('global');
  return (
    <Section>
      <Container>
        <Content>
          <div
            style={{
              width: '100%',
              maxWidth: '300px',
              height: 'auto',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto',
            }}
          >
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 32 32"
              xmlns="http://www.w3.org/2000/svg"
              style={{
                animation: 'logoFloat 3s ease-in-out infinite',
                filter: 'drop-shadow(0 4px 8px rgba(124, 58, 237, 0.3))',
              }}
            >
              <defs>
                <linearGradient
                  id="mainGradient"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="100%"
                >
                  <stop
                    offset="0%"
                    style={{ stopColor: '#7C3AED', stopOpacity: 1 }}
                  />
                  <stop
                    offset="100%"
                    style={{ stopColor: '#1E40AF', stopOpacity: 1 }}
                  />
                </linearGradient>
                <linearGradient
                  id="borderGradient"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="100%"
                >
                  <stop
                    offset="0%"
                    style={{ stopColor: '#34D399', stopOpacity: 0.8 }}
                  />
                  <stop
                    offset="100%"
                    style={{ stopColor: '#A78BFA', stopOpacity: 0.8 }}
                  />
                </linearGradient>
              </defs>
              <circle
                cx="16"
                cy="16"
                r="15"
                fill="url(#mainGradient)"
                stroke="url(#borderGradient)"
                strokeWidth="1"
              />
              <g transform="translate(6, 6)">
                <rect
                  x="2"
                  y="2"
                  width="2.5"
                  height="16"
                  fill="#FFFFFF"
                  rx="1.25"
                />
                <rect
                  x="4.5"
                  y="2"
                  width="8"
                  height="2.5"
                  fill="#FFFFFF"
                  rx="1.25"
                />
                <rect
                  x="4.5"
                  y="8.75"
                  width="6"
                  height="2.5"
                  fill="#FFFFFF"
                  rx="1.25"
                />
                <rect
                  x="10"
                  y="4.5"
                  width="2.5"
                  height="4.25"
                  fill="#FFFFFF"
                  rx="1.25"
                />
                <rect
                  x="7.5"
                  y="11.25"
                  width="2.5"
                  height="6.75"
                  fill="#FFFFFF"
                  rx="1.25"
                  transform="rotate(30 8.75 14.625)"
                />
                <circle
                  cx="15"
                  cy="5"
                  r="1.2"
                  fill="#34D399"
                  style={{
                    animation: 'accentPulse 2s ease-in-out infinite',
                    animationDelay: '0s',
                  }}
                />
                <circle
                  cx="15"
                  cy="9"
                  r="0.8"
                  fill="#FBBF24"
                  opacity="0.9"
                  style={{
                    animation: 'accentPulse 2s ease-in-out infinite',
                    animationDelay: '0.7s',
                  }}
                />
                <circle
                  cx="15"
                  cy="12.5"
                  r="0.6"
                  fill="#A78BFA"
                  opacity="0.7"
                  style={{
                    animation: 'accentPulse 2s ease-in-out infinite',
                    animationDelay: '1.4s',
                  }}
                />
              </g>
            </svg>
          </div>
          <Item>
            <h1>{t('whoAreWe.title')}</h1>
            <p>{t('whoAreWe.consist')}</p>
            <p>{t('whoAreWe.specialize')}</p>
            <p>{t('whoAreWe.clients')}</p>
            {/* <p>{t('whoAreWe.react')}</p> */}
          </Item>
        </Content>
      </Container>
    </Section>
  );
};

export default WhoAreWe;
